// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kh77Y","content":"styles_content__LAqts"};